// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P1Y7","colMin":"styles_colMin__3Zqci"};